import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import arraySort from 'array-sort'
import Modal from 'reboron/DropModal'
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl'

import MarkdownLabel from '../../mini/MarkdownLabel'
import DraggableListComponent from '../../mini/DraggableListComponent'
import NotYetSpecified from '../../mini/NotYetSpecified'
import Indicator from '../readability/Indicator'
import ModalComponent from '../../mini/ModalComponent'
import ResourcesList from '../activity/resources/ResourcesList'

import {
  deleteActivity,
  editActivityPosition,
  fetchQuestActivityNotes
} from '../../../actions/activity'
import { postLoggingInfo } from '../../../actions/logging'
import { showModal } from '../../../actions/modal'
import { findActivity, setActiveMenuItem } from '../../../utils/quest'
import { mapResources, isYoutubeLink } from '../../../utils/resources'
import { activityGoalOrgLabel } from '../../../utils/orglabels'
import {
  descriptionMessage,
  requiresArtifact,
  activityResources,
  justFor,
  mentors,
  notesForMentors,
  assessmentQuestions,
  yes,
  no,
  artifactDescription
} from '../../../utils/messages'
import { messages } from '../../../utils/messages/confirm'
import { formatModalWarningMessageProp } from '../../../utils/multipleeditors'
import {
  unsubscribeFromAllChannelsWithPrefix,
  hasNeededPusherConnection
} from '../../../utils/pusher'
import { flashDraggableItem } from '../../../utils/draggableitem'
import {
  hasReadabilityStats,
  getSectionScores
} from '../../../utils/readability'

class Activity extends Component {
  constructor(props) {
    super(props)
    this.onDeleteActivityClickBound = this.onDeleteActivityClick.bind(this)
    this.onEditActivityClickBound = this.onEditActivityClick.bind(this)
    this.onCreateActivityClickBound = this.onCreateActivityClick.bind(this)
    this.onSortActivitiesClickBound = this.onSortActivitiesClick.bind(this)
    this.onCloseModalClickBound = this.onCloseModalClick.bind(this)
    this.handleReSortActivityBound = this.handleReSortActivity.bind(this)
    this.checkMultipleEditorsBound = this.checkMultipleEditors.bind(this)
    this.onActualEditClickBound = this.onActualEditClick.bind(this)
    this.hideModalBound = this.hideModal.bind(this)
    this.confirmMultipleUsersEditBound =
      this.confirmMultipleUsersEdit.bind(this)
    this.cancelMultipleUsersEditBound = this.cancelMultipleUsersEdit.bind(this)
    this.onResourceClickBound = this.onResourceClick.bind(this)
    this.state = {
      presenceChannelModalMessage: {}
    }
  }

  componentDidMount() {
    // this.multipleEditorsWarningModal = this.refs.multipleEditorsWarningModal.refs.modal
    this.sortActivitiesModal = this.refs.sortActivitiesModal
    if (this.props.activityId) {
      setActiveMenuItem(this.props.activityId)
    }
    this.props.dispatch(fetchQuestActivityNotes(this.props.questId))
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activityId !== this.props.activityId) {
      this.props.dispatch(fetchQuestActivityNotes(nextProps.questId))
    }
  }

  componentDidUpdate() {
    if (this.props.activityId) {
      setActiveMenuItem(this.props.activityId)
    }
  }

  render() {
    const {
      quest,
      activityId,
      activityNotes,
      allowEdit,
      dispatch,
      currentOrg,
      activities
    } = this.props

    const activityIndex = activities.findIndex(function (activity) {
      return activity.id === activityId
    })
    const activity = findActivity(activities, activityId)
    const resources = activity ? mapResources(activity.resources) : ''
    const checkpoint = activity ? activity.checkpoint : ''
    const activityNotesSorted = arraySort(activityNotes, ['sort_order'])

    const modalStyle = {
      width: '800px',
      border: '1px solid rgba(0,0,0,0.2)',
      borderRadius: '6px'
    }

    return (
      <div className="activities-list">
        {/* If navigating from a topic (for example), the activity is undefined at first because the quest hasn't been loaded. */}
        {!activity && <div className="loading" />}
        {activity && (
          <div>
            <div className="yellow" />
            <div className="section-inner">
              <div className="activities-actions">
                {allowEdit && (
                  <div
                    id="add-activity"
                    onClick={this.onCreateActivityClickBound}
                  >
                    <FormattedMessage
                      id={'Quest.Activity.AddActivity'}
                      defaultMessage={'Add Activity'}
                    />
                  </div>
                )}
                {allowEdit && activities.length > 1 && (
                  <div
                    id="sort-activities"
                    onClick={this.onSortActivitiesClickBound}
                  >
                    <FormattedMessage
                      id={'Quest.Activity.SortActivities'}
                      defaultMessage={'Sort Activities'}
                    />
                  </div>
                )}
              </div>
              <div className="activities">
                {checkpoint && (
                  <div className="checkpoint">
                    <FormattedHTMLMessage
                      id={'Quest.Activity.Checkpoint'}
                      defaultMessage={'&nbsp;&nbsp;&nbsp;&nbsp;Check-in'}
                    />
                  </div>
                )}
                <div className="activity-name">
                  <div className="name-wrapper">
                    <div className="thename">
                      {activityIndex + 1}. {activity.name}
                    </div>
                  </div>
                  {allowEdit && (
                    <div
                      className="edit"
                      onClick={this.onEditActivityClickBound}
                    />
                  )}
                  {allowEdit && (
                    <div
                      className="trash"
                      onClick={this.onDeleteActivityClickBound}
                    >
                      &nbsp;
                    </div>
                  )}
                </div>

                <div className="title">
                  {activityGoalOrgLabel(currentOrg)}
                  <div className="requiredtool" />
                </div>
                <div className="view-fields">
                  <MarkdownLabel
                    id="view-activity-goals"
                    value={activity.goals}
                    additionalCssClasses="activity-goals"
                  />
                  {hasReadabilityStats(activity, 'goals') && (
                    <Indicator
                      quest={quest}
                      section={'activity'}
                      subsection={'goals'}
                      dispatch={dispatch}
                      scores={getSectionScores(activity, 'goals')}
                      readableStatsObject={activity}
                    />
                  )}
                </div>

                <div className="title">
                  {descriptionMessage}
                  <div className="requiredtool" />{' '}
                </div>
                <div className="view-fields">
                  <MarkdownLabel
                    id="view-description"
                    value={activity.description}
                  />
                  {hasReadabilityStats(activity, 'description') && (
                    <Indicator
                      quest={quest}
                      section={'activity'}
                      subsection={'description'}
                      dispatch={dispatch}
                      scores={getSectionScores(activity, 'description')}
                      readableStatsObject={activity}
                    />
                  )}
                </div>

                <div className="title">{requiresArtifact}</div>
                <div className="view-fields">
                  <label>{activity.work_product ? yes : no}</label>
                </div>
                {activity.work_product && (
                  <React.Fragment>
                    <div>
                      <div className="title">
                        Artifact Type
                        <div className="requiredtool" />
                      </div>
                      <div className="view-fields">
                        {activity.artifact_type ? (
                          <label>{activity.artifact_type.name}</label>
                        ) : (
                          <NotYetSpecified />
                        )}
                      </div>
                    </div>
                    <div>
                      <div className="title">{artifactDescription}</div>
                      <div className="view-fields">
                        <MarkdownLabel
                          id="artifact-description"
                          value={activity.artifact_description}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}

                <div className="title">{activityResources}</div>
                <div className="view-fields">
                  {resources.length === 0 ? (
                    <NotYetSpecified />
                  ) : (
                    <ResourcesList
                      resources={resources}
                      handleResourceClick={this.onResourceClickBound}
                      activity={activity}
                    />
                  )}
                </div>

                {this.hasNotes(activity) && (
                  <div id="justForMentors">
                    <div className="just-for-mentors-label">
                      {justFor}&nbsp;<span className="label">{mentors}</span>
                    </div>

                    <div className="title">{notesForMentors}</div>
                    <div className="view-fields">
                      <MarkdownLabel
                        id="view-inline-notes"
                        value={activity.inline_notes}
                      />
                    </div>

                    <div className="title">
                      <FormattedMessage
                        id={'Quest.Activity.FilesForMentors'}
                        defaultMessage={'Files for Mentors'}
                      />
                    </div>
                    <div className="view-fields">
                      <div id="mentorNotesSection">
                        {activityNotes.length > 0 ? (
                          <ul
                            className="mentor-note-list"
                            id="mentorNoteListEl"
                          >
                            {activityNotesSorted.map((note, index) => {
                              return (
                                <li key={index}>
                                  <div className="mentor-note-wrapper">
                                    <div className={'icon ' + note.file_type} />
                                    <div className={'name'}>
                                      <a
                                        target="=_blank"
                                        rel="noreferrer noopener"
                                        href={note.attachment_url}
                                      >
                                        {note.attachment_name}
                                      </a>
                                    </div>
                                    {note.description && (
                                      <div className="description">
                                        {note.description}
                                      </div>
                                    )}
                                  </div>
                                </li>
                              )
                            })}
                          </ul>
                        ) : (
                          <NotYetSpecified />
                        )}
                      </div>
                    </div>

                    <div className="title">{assessmentQuestions}</div>
                    <div className="view-fields">
                      <MarkdownLabel
                        id="view-mentor-assessment-questions"
                        value={activity.mentor_assessment_questions}
                      />
                    </div>
                  </div>
                )}
                <Modal
                  ref="sortActivitiesModal"
                  className="sort-activities-modal"
                  modalStyle={modalStyle}
                >
                  <div className="modal-dialog" id="sortActivitiesModal">
                    <div
                      className="close"
                      onClick={this.onCloseModalClickBound}
                    />
                    <div id="reSortActivities">
                      <DraggableListComponent
                        list={activities}
                        editListItemPosition={this.handleReSortActivityBound}
                        itemType={'activity'}
                        hideEdit
                        hideDelete
                        hideDescription
                      />
                    </div>
                  </div>
                </Modal>
                <ModalComponent
                  ref="multipleEditorsWarningModal"
                  klass="modal multiple-editors-modal"
                  modalId="multipleEditorsWarningModal"
                  headingKlass="modal-heading"
                  logoKlass="logo multiple-editors"
                  headingText="Edit in Progress"
                  bodyText={this.state.presenceChannelModalMessage}
                  primaryButtonText="Cancel"
                  secondaryButtonText="Edit Anyway"
                  primaryButtonAction={this.cancelMultipleUsersEditBound}
                  secondaryButtonAction={this.confirmMultipleUsersEditBound}
                  setRawHtmlInBody
                  cancelAction={this.cancelMultipleUsersEditBound}
                  handleNonButtonCancelAction={
                    this.cancelMultipleUsersEditBound
                  }
                />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  hasNotes(activity) {
    return (
      (activity.inline_notes && activity.inline_notes.length > 0) ||
      (activity.mentor_assessment_questions &&
        activity.mentor_assessment_questions.length > 0) ||
      this.props.activityNotes.length > 0
    )
  }

  onDeleteActivityClick() {
    const { dispatch, quest, activityId, intl } = this.props
    const intlConfirmation = intl.formatMessage(messages.deleteActivity)
    const confirmation = confirm(intlConfirmation)
    if (confirmation) {
      dispatch(deleteActivity(quest.id, activityId))
    }
  }

  onEditActivityClick() {
    if (!hasNeededPusherConnection(window.oeQMQuestPusherInstance)) {
      return this.onActualEditClick()
    }
    this.presenceChannel = window.oeQMQuestPusherInstance.subscribe(
      `presence-activity-${this.props.activityId}`
    )
    this.presenceChannel.bind(
      'pusher:subscription_succeeded',
      this.checkMultipleEditorsBound
    )
    this.presenceChannel.bind(
      'pusher:subscription_failed',
      this.onActualEditClickBound
    )
  }

  checkMultipleEditors() {
    // check if anyone else is subscribed to this channel
    if (
      Object.keys(this.presenceChannel.members.members).length > 0 &&
      Object.keys(this.presenceChannel.members.members).some(
        m => JSON.parse(m) !== this.props.user.id
      )
    ) {
      this.setState(() => ({
        presenceChannelModalMessage: formatModalWarningMessageProp(
          this.presenceChannel.members,
          this.props.user.id
        )
      }))
      this.refs.multipleEditorsWarningModal.refs.modal.show()
    } else {
      this.props.dispatch(
        push(
          `/quest/${this.props.quest.id}/activities/${this.props.activityId}/edit`
        )
      )
    }
  }

  onActualEditClick() {
    this.props.dispatch(
      push(
        `/quest/${this.props.quest.id}/activities/${this.props.activityId}/edit`
      )
    )
    if (this.presenceChannel) {
      this.presenceChannel.trigger(
        'client-edit',
        this.presenceChannel.members.me
      )
    }
    this.refs.multipleEditorsWarningModal.refs.modal.hide()
  }

  onCreateActivityClick() {
    const { dispatch, quest } = this.props
    dispatch(push(`/quest/${quest.id}/activities/add`))
  }

  onSortActivitiesClick() {
    this.sortActivitiesModal.show()
  }

  onCloseModalClick() {
    this.sortActivitiesModal.hide()
  }

  handleReSortActivity(activityId, newIndex) {
    const { dispatch, quest } = this.props
    dispatch(editActivityPosition(quest.id, activityId, newIndex))
    // Find the node and flash orange
    var _el = document.getElementById(`activity-${activityId}`)
    flashDraggableItem(_el)
  }

  hideModal() {
    this.refs.multipleEditorsWarningModal.refs.modal.hide()
  }

  confirmMultipleUsersEdit() {
    const { quest, dispatch, activityId, activities } = this.props
    const activity = findActivity(activities, activityId)

    let data = {
      action: 'update',
      section: 'activities',
      quest: {
        id: quest.id,
        name: quest.name
      },
      activity: {
        id: activity.id,
        name: activity.name
      }
    }
    dispatch(postLoggingInfo('quest_multiple_editors', data))

    this.onActualEditClick()
  }

  cancelMultipleUsersEdit() {
    const { quest, dispatch, activityId, activities } = this.props

    if (window.oeQMQuestPusherInstance) {
      unsubscribeFromAllChannelsWithPrefix(
        window.oeQMQuestPusherInstance,
        'presence'
      )
    }

    const activity = findActivity(activities, activityId)

    let data = {
      action: 'cancel',
      section: 'activities',
      quest: {
        id: quest.id,
        name: quest.name
      },
      activity: {
        id: activityId,
        name: activity.name
      }
    }
    dispatch(postLoggingInfo('quest_multiple_editors', data))
    this.hideModal()
  }

  onVideoViewerOpenClick(resource, activity) {
    const { quest, activities } = this.props
    this.props.dispatch(
      showModal('VIDEO_VIEWER', {
        quest,
        activity,
        resource,
        activities
      })
    )
  }

  onResourceClick(resource, activity) {
    if (isYoutubeLink(resource.url, resource.resource_type)) {
      this.onVideoViewerOpenClick(resource, activity)
    } else {
      window.open(
        resource.file_url ? resource.file_url : resource.url,
        '_blank'
      )
    }
  }
}

Activity.propTypes = {
  dispatch: PropTypes.func,
  quest: PropTypes.object,
  activityId: PropTypes.number,
  questId: PropTypes.number,
  activityNotes: PropTypes.array,
  allowEdit: PropTypes.bool,
  currentOrg: PropTypes.object,
  intl: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  activities: PropTypes.array.isRequired
}

const mapStateToProps = state => ({
  questId: state.quest.item.id,
  activityId: state.quest.activityId || state.quest.activities[0].id,
  activityNotes: state.quest.activityNotes,
  currentOrg: state.organizations.items.find(function (org) {
    return org.id === parseInt(state.organization.orgId)
  }),
  user: state.user.user,
  activities: state.quest.activities
})

export default injectIntl(connect(mapStateToProps)(Activity))
export { Activity as ActivityDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/section/Activity.js